/**
 * setInterval that skips ticks while the tab is hidden.
 *
 * Polling loops (unread counts, presence lists, job status) kept hitting
 * the API from background tabs. This wrapper has the same signature and
 * returns the native interval id, so `clearInterval` works unchanged.
 * The callback runs on the next tick after the tab becomes visible again.
 *
 * Do not use it for elapsed-time counters that add to local state on each
 * tick; those would drift. They should compute from a start timestamp.
 */
export function visibleInterval(fn, ms, ...args) {
  return setInterval(() => {
    if (typeof document !== 'undefined' && document.hidden) return;
    fn(...args);
  }, ms);
}

export default visibleInterval;
